exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".select-autosuggest {\n  width: 50%; }\n\n.select-search {\n  margin-bottom: 20px; }\n\n.value-container div {\n  margin: 0;\n  padding: 0; }\n\n.value-container {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  padding-right: 20px; }\n  .value-container input {\n    -ms-flex-item-align: end;\n    align-self: flex-end; }\n\n.dropdown-indicator {\n  padding: 0 0 5px !important;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: end;\n  justify-content: flex-end; }\n  .dropdown-indicator svg {\n    fill: #777777; }\n\n.noOptionsMessage {\n  padding: 5px 10px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/basic/SelectSearch/SelectSearch.scss
// module id = 1254
// module chunks = 0